// src/components/ProtectedRoute.js

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // UPDATED: Import useAuth

// UPDATED: The component now accepts an `adminOnly` prop
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { currentUser } = useAuth();

  // If there is no logged-in user, redirect to the login page
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // If this route is admin-only and the user is not an admin,
  // redirect them to their dashboard.
  if (adminOnly && currentUser.role !== 'admin') {
    return <Navigate to="/dashboard" />;
  }

  // If all checks pass, render the child components
  return children;
};

export default ProtectedRoute;